<div class="header">
  <h3>{{'IMPORT-DATA.TITLE' | translate}}</h3>
</div>
<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="searchButtonClicked()" (clear)="clearSearch()"></app-filter-header>
  <div class="row row-eq-height">
    <div class="col-md-4">
      <div class="form-label-group">
        <input class="form-control" type="text" id="documentNumber" [(ngModel)]="documentNumber"
               placeholder="{{ 'IMPORT-DATA.DOCUMENT-NO' | translate }}">
        <label for="documentNumber">{{ 'IMPORT-DATA.DOCUMENT-NO' | translate }}</label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="documentType"
          [options]="importMethod"
          [(ngModel)]="selectedMethod"
          [autoDisplayFirst]="false"
          id='importMethod'
          placeholder="{{'IMPORT-DATA.IMPORT-METHOD' | translate}}"
          [style]="{'z-index': 3}">
        >
        </p-dropdown>
        <label for="statusData">{{'IMPORT-DATA.IMPORT-METHOD' | translate}}</label>
      </div>
    </div>
  </div>
  <div class="row row-eq-height m-t-10">
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="documentType"
          [options]="statusData"
          [(ngModel)]="selectedStatus"
          [autoDisplayFirst]="false"
          id='statusData'
          placeholder="{{'IMPORT-DATA.STATUS-TYPE' | translate}}"
        >
        </p-dropdown>
        <label for="statusData">{{'IMPORT-DATA.STATUS-TYPE' | translate}}</label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="dropdown" #dd="ngbDropdown" ngbDropdown placement="bottom-right" autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange"
                 ngbDropdownToggle placeholder="{{'TABLE.IMPORT-DATE' | translate}}" readonly>
          <label for="calendarDropdown">{{'TABLE.IMPORT-DATE' | translate}}</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
          </div>
          <div (click)="stopPropagation($event)">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="box-parent position-relative z-1">
  <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    [maxSize]="5"
    (pageChange)="pageChanged()"
    (optionChange)="searchButtonClicked()"
    *ngIf="loading === false && totalItems !== 0"
  >
  </app-custom-pagination>
  <div class="row m-t-20" *ngIf="totalItems === 0 && loading === false">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>
  <div class="m-t-20 text-center scrollable">
    <p-table #tt tableStyleClass="table" *ngIf="totalItems !== 0" [loading]="loading"
             [value]="tableData" [customSort]="true" (onSort)="sort($event)" [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">{{'NORMAL.QUE' | translate}}</th>
          <th [pSortableColumn]="'created_at'" (click)="pageChanged()">{{'TABLE.IMPORT-DATE' | translate}}</th>
          <th [pSortableColumn]="'method'" (click)="pageChanged()">{{'IMPORT-DATA.METHOD' | translate}}</th>
          <th scope="col">{{'IMPORT-DATA.CSV-NAME' | translate}}</th>
          <th [pSortableColumn]="'invoice_number'" (click)="pageChanged()">{{'FILTER.DOCUMENT-NUMBER' | translate}}</th>
          <th [pSortableColumn]="'status'" (click)="pageChanged()">{{'IMPORT-DATA.STATUS' | translate}}</th>
          <th scope="col">{{'IMPORT-DATA.INPUT-FILE' | translate}}</th>
          <th scope="col">{{'IMPORT-DATA.ERROR-MESSAGES' | translate}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td>{{data.created_at | date:"dd/MM/yyyy HH:mm" }}</td>
          <td>{{data.method}}</td>
          <td>{{data.csv_name}}</td>
          <td>{{data.invoice_number}}</td>
          <td>{{data.status_display | translate}}</td>
          <td>
            <button *ngIf="data.csv_name !== '-'" class="btn btn-dv" style="padding:0rem 0.5rem 0rem 0.5rem">
              <i class="fas fa-file-csv" title="CSV" (click)="downloadCsvOrPdfFile(data.csv_name, data.csv_file)">
              </i>
            </button>
            <button *ngIf="data.pdf_name !== '-'" class="btn btn-dv" style="padding:0rem 0.5rem 0rem 0.5rem">
              <i class="fas fa-file-pdf" (click)="downloadCsvOrPdfFile(data.pdf_name, data.pdf_file)">
              </i>
            </button>
            <button *ngIf="data.method === 'Import JSON'" class="btn btn-dv" style="padding:0rem 0.5rem 0rem 0.5rem">
              <i class="fas fa-file-alt" (click)="downloadJsonFile(data.json)">
              </i>
            </button>
          </td>
          <td style="text-align: center" *ngIf="data.status_display === 'DASHBOARD.FAILED'">
            <i (click)="resolveError($event, popup, data)" class="fas fa-eye" aria-hidden="true"></i>
          </td>
          <td style="text-align: center" *ngIf="data.status_display !== 'DASHBOARD.FAILED'">
            <span>-</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="row m-t-20" *ngIf="loading">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>
<!-------------------------modal popup------------------------------------------->
<ng-template #popup let-modal>
  <div class="modal-header">
    <h4>{{'IMPORT-DATA.ERROR-MESSAGES' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="revertBack()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body bg-model">
    <h6>{{'IMPORT-DATA.ROW' | translate}}: {{modalData.row}}</h6>
    <ul *ngFor="let res of modalData.detail;  let i = index">
      <li>
        {{res}}
      </li>
    </ul>
  </div>
  <div class="modal-footer">
    <div class="text-center">
      <button type="button" class="btn btn-dv btn-danger btn-wide redius-border"
              (click)="revertBack()">{{'COMMON.CLOSE' | translate}}
      </button>
    </div>
  </div>
</ng-template>




// WEBPACK FOOTER //
// /opt/app/src/app/features/import-data/import-data.component.html